import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'hourWarning',
    'hourAlert',
    'weeklyHourInput',
  ];

  connect() {
    if (this.hasWeeklyHourInputTarget) {
      this.weeklyHourInputTarget.addEventListener('input', () => {
        this.displayAlerts();
      });
    }
  }

  displayAlerts() {
    const weeklyHours = parseInt(this.weeklyHourInputTarget.value);

    if (weeklyHours >= 46 && weeklyHours <= 48) {
      this.hourAlertTarget.classList.add('d-none');
      this.hourWarningTarget.classList.remove('d-none');
    } else if (weeklyHours > 48) {
      this.hourWarningTarget.classList.add('d-none');
      this.hourAlertTarget.classList.remove('d-none');
    } else {
      this.hourAlertTarget.classList.add('d-none');
      this.hourWarningTarget.classList.add('d-none');
    }
  }
}
